import { convertCategoryCodeToName } from "@/api/fetchDisclosureList/common/convertCategoryCodeToName";
import { parseDocUrl } from "@/api/fetchDisclosureList/common/parseDocUrl";
import { parseTopic } from "@/api/fetchDisclosureList/common/parseTopic";
import { GQL_EXCHANGE_TYPE } from "@/shared/Disclosure/types/GQL/enum/ExchangeType";
import { PV_DISCLOSURE_ITEM } from "@/types/PresenterModel/PV_DISCLOSURE_ITEM";
import { API_RES_HANOI_LIST_ITEM } from "@/types/apiModel/Disclosure/API_RES_DISCLOSURE_HANOI";

const exchangeType = GQL_EXCHANGE_TYPE.HANOI;

async function parseItem(
  v: API_RES_HANOI_LIST_ITEM
): Promise<PV_DISCLOSURE_ITEM | null> {
  if (!v.id) return null;

  const fileUrl = parseDocUrl(exchangeType, v.details.fileLink?.[0]);

  return {
    id: v.id,
    dataDate: v.dataDate ?? "",
    securityCode: v.details.secCode,
    securityName: v.korName ?? "",
    orgSecurityName: v.details.secCode?.[0] ?? "",
    categoryCode: v.details.categoryId,
    categoryName: await convertCategoryCodeToName(
      exchangeType,
      v.details.categoryId
    ),
    fileUrl:
      fileUrl || "https://www.hnx.vn/en-gb/thong-tin-cong-bo-ny-tcph.html",
    tags: parseTopic(v.analysisDetails.topicKor),
    summaryShort: v.analysisDetails.summarizeTinyKor ?? "",
    summaryLong:
      (v.analysisDetails.summarizeLongKor ?? "").trim() +
      (fileUrl
        ? ""
        : "\n" +
          `(*이 공시에는 원문에 대한 직접 링크가 제공되지 않습니다. 원문 링크에서 ${v.details.secCode}를 검색하여 확인해보세요.)`),
    exchangeType,
    formData: null
  };
}

export default parseItem;
